import AwardWinnerWithPointsResults from './AwardWinnerWithPointsResults';
import LocationTally from './LocationTally';

class AwardsWinnerWithPointsData {
  results = [];

  totals = null;

  constructor(data = [], totals = {}, awardNames = []) {
    this.results = AwardWinnerWithPointsResults.fromList(data);
    this.totals = LocationTally.fromObject(totals).setTally(totals);
  }
}

export default AwardsWinnerWithPointsData;
